import { render, staticRenderFns } from "./SetupPassword.vue?vue&type=template&id=fda51d3a&scoped=true&"
import script from "./SetupPassword.vue?vue&type=script&lang=js&"
export * from "./SetupPassword.vue?vue&type=script&lang=js&"
import style0 from "./SetupPassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SetupPassword.vue?vue&type=style&index=1&id=fda51d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda51d3a",
  null
  
)

export default component.exports